import React, { useState } from 'react';
import { PredefinedPhrase } from '../../PredefinedPhrasesSetup/PredefinedPhrasesList';
import PredefinedPhraseSelectionItem from './../PredefinedPhraseSelectionItem/PredefinedPhraseSelectionItem';
// @ts-ignore
import styles from './PredefinedPhraseSelection.module.scss';
import FlatList from '../../../../Base/Components/FlatList';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import useMyPhrases from '../../../Hooks/useMyPhrases';
import useFlatData from '../../../../Base/Hooks/useFlatData';
import {
	PhraseType,
	useLazyMyPhrasesQuery,
} from '../../../../../graphql/graphql';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import PredefinedPhrasesSetupModal from '../../PredefinedPhrasesSetup/PredefinedPhrasesSetupModal';

interface Props {
	onSelect: (item: PredefinedPhrase) => void;
	type: PhraseType;
}

const WRAPPER_ID = 'predefinedPhraseSelectionWrapper';

const PredefinedPhraseSelection: React.FC<Props> = ({ onSelect, type }) => {
	const [getMyPhrasesQuery, { data, isLoading }] = useLazyMyPhrasesQuery();
	const [isSetupOpen, setIsSetupOpen] = useState(false);

	const { getMyPhrases, getNextPage, page, setPage } =
		useMyPhrases(getMyPhrasesQuery);

	const { flatData, hasMoreData, loadData } = useFlatData(
		getMyPhrases,
		{
			data: data?.myPhrases?.data,
			totalPages: data?.myPhrases?.meta?.totalPages,
			page: data?.myPhrases?.meta?.page,
		},
		page,
		setPage,
		{
			type,
		},
	);

	return (
		<div className={styles.wrapper}>
			<div className={styles.controls}>
				<LinkButton
					title='base.phrasesSetup'
					theme={Theme.BLUE}
					onClick={() => setIsSetupOpen(true)}
				/>
				{isSetupOpen && (
					<PredefinedPhrasesSetupModal
						isOpen
						onClose={() => setIsSetupOpen(false)}
						onEdit={loadData}
					/>
				)}
			</div>
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={WRAPPER_ID}
					itemKey={'id'}
					className={styles.list}
					renderItem={item => (
						<PredefinedPhraseSelectionItem item={item} onSelect={onSelect} />
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default PredefinedPhraseSelection;
